<section class="nrc-certs">
  <div class="nrc-certs__centered">
    <div class="nrc-certs__intro">
      <span class="nrc-certs__badge">Certifications</span>
      <h2 class="nrc-certs__heading">Our partners are certified by</h2>
    </div>
    <div class="nrc-certs__carousel">
      <button type="button" class="nrc-certs__nav nrc-certs__nav--prev" aria-label="Previous certifications" (click)="prev()">
        <img src="assets/images/chevron-left.svg" alt="" width="24" height="24" />
      </button>
      <swiper-container #swiperRef init="false" class="nrc-certs__swiper">
        <swiper-slide *ngFor="let item of partners">
          <div class="nrc-certs__item">
            <picture>
              <source [srcset]="'assets/images/' + item.webp" type="image/webp" />
              <img [src]="'assets/images/' + item.logo" [alt]="item.logo" loading="lazy" />
            </picture>
          </div>
        </swiper-slide>
      </swiper-container>
      <button type="button" class="nrc-certs__nav nrc-certs__nav--next" aria-label="Next certifications" (click)="next()">
        <img src="assets/images/chevron-right.svg" alt="" width="24" height="24" />
      </button>
    </div>
  </div>
</section>
